<template>
    <canvas
        width="460"
        height="490"
        ref="canvas"
        class="qrcode-canvas"/>
</template>

<script>
 import Background from "./Background.vue"
 import { qrcanvas } from 'qrcanvas';

 import message from "ant-design-vue/lib/message";

 export default {
     name: 'RenderQRCode',
     data() {
         return {
             backgroundImage: null,
             images: []
         }
     },
     components: {
         Background
     },
     props: {
     },
     computed: {
     },
     mounted() {
         this.images = JSON.parse(sessionStorage.getItem("renderQRCodeInfo"))

         var that = this
         var img = new Image();
         img.crossOrigin = "Anonymous"
         img.src = 'https://goldbox-static.oss-cn-shanghai.aliyuncs.com/staff/qr_code_bg.png'
         img.addEventListener("load",function() {
             if (that.backgroundImage === null) {
                 that.backgroundImage = img
             }

             that.downloadImages()
         }, false);
     },
     methods: {
         downloadImages() {
             var imageNumber = this.images.length

             for (var i = 0; i < this.images.length; i++) {
                 this.downloadImage(this.images[i])
             }

             message.success(imageNumber + " 张二维码下载完毕")
         },
         downloadImage(code) {
             var canvas = this.$refs.canvas.getContext("2d")
             canvas.drawImage(this.backgroundImage,0,0);
             var qrcodeCanvas = qrcanvas({
                 data: decodeURIComponent("https://consumer.hibox.vip/m/" + code),
                 size: 400
             });

             canvas.drawImage(qrcodeCanvas, 30, 60)

             canvas.font = 'bold 45px Arial'
             canvas.fillText("编号: " + code, 100, 45)

             let link = document.createElement('a');
             link.href = this.$refs.canvas.toDataURL();
             link.setAttribute('download', code + '.png');
             link.style.display = 'none';
             document.body.appendChild(link);
             link.click();
         }
     },
 }
</script>

<style scoped>
</style>
